import React, { useState, useEffect } from 'react';
import { getDocumentStats } from '../utils/office';
import { colors, fontSizes, fontWeights } from '../theme/theme';

const DocumentContext = () => {
  const [stats, setStats] = useState({ wordCount: 0, characterCount: 0, paragraphCount: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadStats = async () => {
      try {
        const documentStats = await getDocumentStats();
        setStats(documentStats);
      } catch (error) {
        console.error("Error loading document stats:", error);
      } finally {
        setLoading(false);
      }
    };

    loadStats();
    
    // Refresh stats every 30 seconds
    const interval = setInterval(loadStats, 30000);
    return () => clearInterval(interval);
  }, []);

  const containerStyle = {
    padding: '8px 12px',
    background: colors.surface,
    borderBottom: `1px solid ${colors.border}`,
    fontSize: fontSizes.small,
    color: colors.textSecondary,
  };

  const statsStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  };

  const statItemStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '2px',
  };

  const statValueStyle = {
    fontWeight: fontWeights.medium,
    color: colors.textPrimary,
  };

  const statLabelStyle = {
    fontSize: fontSizes.small,
    color: colors.textSecondary,
  };

  if (loading) {
    return (
      <div style={containerStyle}>
        <div style={{ textAlign: 'center' }}>📄 Yükleniyor...</div>
      </div>
    );
  }

  return (
    <div style={containerStyle}>
      <div style={statsStyle}>
        <div style={statItemStyle}>
          <span style={statValueStyle}>{stats.wordCount}</span>
          <span style={statLabelStyle}>Kelime</span>
        </div>
        <div style={statItemStyle}>
          <span style={statValueStyle}>{stats.characterCount}</span>
          <span style={statLabelStyle}>Karakter</span>
        </div>
        <div style={statItemStyle}>
          <span style={statValueStyle}>{stats.paragraphCount}</span>
          <span style={statLabelStyle}>Paragraf</span>
        </div>
      </div>
    </div>
  );
};

export default DocumentContext; 